import React, { useEffect, useState } from "react";
import classes from "./HeaderController.module.scss";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { userState } from "../../states/userState";
import {
  VIEW_ID_5253,
  VIEW_ID_54,
  VIEW_ID_ALL_FACTORY,
  VIEW_ID_PT,
  VIEW_ID_PV,
  viewsList,
} from "../../commons/views";
import TextInputForProductNo from "../uikit/atoms/textFields/TextInputForProductNo";
import TextInputForSalesNo from "../uikit/atoms/textFields/TextInputForSalesNo";
import { FetchButton } from "../uikit/atoms/buttons/FetchButton";
import { ExportButton } from "../uikit/atoms/buttons/ExportButton";
import { kintoneArrayState } from "../../states/kintonArrayState";
import { loadingState, loadingText } from "../../states/loadingState";
import { useFetchProcesses } from "../../hooks/useFetchProcesses";
import { ErrorModal } from "../uikit/atoms/modal/ErrorModal";
import { isActiveFetchState, isOnlySearchState } from "../../states/fetchState";
import useCsvDownloader from "../../hooks/export/useCsvDownloarder";
import { User } from "../../types/index";
import { Export, filteredArrayState } from "../../states/filteredArrayState";
import { theme } from "../../theme/theme";
import { foreColor, foreColorOnMouseOver } from "../../commons/colors";
import ProcessDateFilter from "../uikit/organisms/ProcessDateFilter";
import SelectBoxForSituation from "../uikit/molecules/selectboxes/SelectBoxForSituation";
import SelectBoxForFactory from "../uikit/molecules/selectboxes/SelectBoxForFactory";
import TextInputForproductBno from "../uikit/atoms/textFields/TextInputForProductBno";
const HeaderController = () => {
  const user = useRecoilValue<User>(userState);
  const [toggleFocus, setToggleFocus] = useState(false);
  const [productNo, setProductNo] = useState(
    user.filters.productNo.split("-")[0] ?? ""
  );
  const [productBo, setProductBo] = useState(
    user.filters.productNo.split("-")[1] ?? ""
  );

  const filteredArray = useRecoilValue<Export[]>(filteredArrayState);
  const [kintoneArray, setKintoneArray] = useRecoilState(kintoneArrayState);
  const [displayViewString, setDisplayViewString] = useState<string>("全工場");
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const [title, setTitle] = useState("API連携エラー");
  const [message, setMessage] = useState("データ取得に失敗しました");
  const [isShowErrorDialog, setIsShowErrorDialog] = useState(false);
  const [isOnlySearch, setIsOnlySearch] = useRecoilState(isOnlySearchState);
  const [isAciveFetch, setIsAciveFetch] = useRecoilState(isActiveFetchState);
  const { error, getProcessForFactory, getProcessForSite } =
    useFetchProcesses();
  const { downloadCsv } = useCsvDownloader();
  const [isHovered, setIsHovered] = useState(false);
  useEffect(() => {
    const filteredArray = viewsList.filter((view) => view.id === user.viewId);
    setDisplayViewString(filteredArray[0].name);
  }, [user.viewId]);
  const fetchProcessForFactory = async (
    headerOnly = false,
    aProductNo: string,
    aProductBno: string,
    aSalesNo: string
  ) => {
    const factoryIds = user.filters.factory; //全件は0を指定する
    const situations = user.filters.situation; //全件は0を指定する
    // const productNo = user.filters.productNo;
    let productNoStr = aProductNo;
    if (aProductBno) {
      productNoStr = aProductNo + "-" + aProductBno;
    }
    const productNo = productNoStr;
    const salesNo = user.filters.salesNo;
    const dateField = user.filters.dateField;
    const fromDate = user.filters.fromDate;
    const toDate = user.filters.toDate;
    const viewId = user.viewId;
    const productItems = null; //品目区分追加時に実装する
    setLoadingAnimation(true);
    setLoadingText("データ取得中...");
    try {
      const response = await getProcessForFactory({
        factoryIds,
        situations,
        productNo,
        salesNo,
        dateField,
        fromDate,
        toDate,
        headerOnly,
        viewId,
        productItems,
      });
      if (error) throw new Error(error);
      return response;
    } catch (e) {
      setMessage("データ取得に失敗しました");
      setIsShowErrorDialog(true);
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };
  const fetchProcessForSite = async (
    headerOnly = false,
    aProductNo: string,
    aProductBno: string,
    aSalesNo: string
  ) => {
    const factoryIds = user.filters.factory; //全件は0を指定する
    const situations = user.filters.situation; //全件は0を指定する
    // const productNo = user.filters.productNo;
    let productNoStr = aProductNo;
    if (aProductBno) {
      productNoStr = aProductNo + "-" + aProductBno;
    }
    const productNo = productNoStr;
    const salesNo = user.filters.salesNo;
    const dateField = user.filters.dateField;
    const fromDate = user.filters.fromDate;
    const toDate = user.filters.toDate;
    const viewId = user.viewId;
    const productItems = null; //品目区分追加時に実装する
    setLoadingAnimation(true);
    setLoadingText("データ取得中...");
    try {
      const response = await getProcessForSite({
        factoryIds,
        situations,
        productNo,
        salesNo,
        dateField,
        fromDate,
        toDate,
        headerOnly,
        viewId,
        productItems,
      });
      if (error) throw new Error(error);
      return response;
    } catch (e) {
      setMessage("データ取得に失敗しました");
      setIsShowErrorDialog(true);
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };
  const handleFetchButtonClick = async (
    aProductNo: string = "",
    aProductBno: string = "",
    aSalesNo: string = ""
  ) => {
    let result;
    setIsOnlySearch(true);
    setIsAciveFetch(true);
    if (user.viewId !== 9999) {
      result = await fetchProcessForFactory(
        false,
        aProductNo,
        aProductBno,
        aSalesNo
      );
      console.log("result", result);
    } else {
      result = await fetchProcessForSite(
        false,
        aProductNo,
        aProductBno,
        aSalesNo
      );
    }
    if (result == undefined) {
      setKintoneArray([]);
      return;
    }
    setKintoneArray(result);
    console.log("fetch button clicked");
  };
  const handleExportButtonClick = () => {
    let columns;
    let fileNamePrefix;

    switch (user.viewId) {
      case VIEW_ID_ALL_FACTORY:
        columns = user.columnsAllFactory;
        fileNamePrefix = "process_factory_all";
        break;
      case VIEW_ID_PT:
        columns = user.columnsPT;
        fileNamePrefix = "process_factory_pt";
        break;
      case VIEW_ID_PV:
        columns = user.columnsPV;
        fileNamePrefix = "process_factory_pv";
        break;
      case VIEW_ID_54:
        columns = user.columnsKanto;
        fileNamePrefix = "process_factory_kanto";
        break;
      case VIEW_ID_5253:
        columns = user.columnsFukuokaKumamoto;
        fileNamePrefix = "process_factory_fukuoka_kumamoto";
        break;
      default:
        columns = user.columnsSite;
        fileNamePrefix = "process_site";
        break;
    }

    downloadCsv(filteredArray, columns, `${fileNamePrefix}_${user.viewId}`);
  };
  return (
    <>
      <div className={classes.rootContainer}>
        {/* <div className={classes.viewSetName}>
          <div className={classes.caption}>Viewsets</div>
          <div className={classes.name}>{displayViewString}</div>
        </div> */}
        <div className={classes.filters}>
          <div
            className={classes.viewSetName}
            style={
              isHovered
                ? foreColorOnMouseOver(user?.mode ?? "lite")
                : foreColor(user?.mode ?? "lite")
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div className={classes.caption}>Viewsets</div>
            <div className={classes.name}>{displayViewString}</div>
          </div>
          <div className={classes.factory}>
            <div
              style={
                isHovered
                  ? foreColorOnMouseOver(user?.mode ?? "lite")
                  : foreColor(user?.mode ?? "lite")
              }
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              製作工場
            </div>
            <div className={classes.accordion}>
              <SelectBoxForFactory />
            </div>
          </div>
          <div className={classes.productNo}>
            <div
              style={
                isHovered
                  ? foreColorOnMouseOver(user?.mode ?? "lite")
                  : foreColor(user?.mode ?? "lite")
              }
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              製作NO
            </div>
            <div className={classes.textInput}>
              <div>
                <TextInputForProductNo
                  fullWidth={false}
                  label={""}
                  type={"number"}
                  multiline={false}
                  required={false}
                  rows={1}
                  disabled={false}
                  placeholder={"01234567"}
                  setProductNo={setProductNo}
                  productNo={productNo}
                  setProductBno={setProductBo}
                  productBno={productBo}
                  setToggleFocus={setToggleFocus}
                  fetchProcess={handleFetchButtonClick}
                />
              </div>
              <p style={foreColor(user?.mode ?? "lite")}>－</p>
              <div>
                <TextInputForproductBno
                  fullWidth={false}
                  label={""}
                  multiline={false}
                  required={false}
                  type={"number"}
                  rows={1}
                  disabled={false}
                  // InputProps={true}
                  placeholder={"01"}
                  setProductNo={setProductNo}
                  productNo={productNo}
                  setProductBno={setProductBo}
                  productBno={productBo}
                  toggleFocus={toggleFocus}
                  fetchProcess={handleFetchButtonClick}
                />
              </div>
            </div>
          </div>
          {/* <div className={classes.salesNo}>
            <div
              style={
                isHovered
                  ? foreColorOnMouseOver(user?.mode ?? "lite")
                  : foreColor(user?.mode ?? "lite")
              }
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              担当営業NO
            </div>
            <div className={classes.textInput}>
              <TextInputForSalesNo
                fullWidth={false}
                label={""}
                multiline={false}
                required={false}
                type={""}
                rows={1}
                disabled={false}
                // InputProps={true}
                placeholder={"01234"}
              />
            </div>
          </div> */}
          <div className={classes.dateSelector}>
            <ProcessDateFilter />
          </div>
          <div className={classes.situation}>
            <div
              style={
                isHovered
                  ? foreColorOnMouseOver(user?.mode ?? "lite")
                  : foreColor(user?.mode ?? "lite")
              }
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              状況区分
            </div>
            <div className={classes.accordion}>
              <SelectBoxForSituation />
            </div>
          </div>
          <div className={classes.buttons}>
            <div className={classes.fetch}>
              <FetchButton
                disabled={false}
                onClick={() =>
                  handleFetchButtonClick(
                    user.filters.productNo.split("-")[0],
                    user.filters.productNo.split("-")[1],
                    user.filters.salesNo
                  )
                }
                caption={"Get latest"}
              />
            </div>
            <div className={classes.export}>
              <ExportButton
                disabled={false}
                onClick={handleExportButtonClick}
                caption={"Export CSV"}
              />
            </div>
          </div>
        </div>
      </div>
      {isShowErrorDialog && (
        <ErrorModal
          title={title}
          message={message}
          setIsShow={setIsShowErrorDialog}
        />
      )}
    </>
  );
};

export default HeaderController;
